import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48a2f017"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt", "src", "title"]

import { computed, onMounted, Ref, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImage',
  props: {
    src: {},
    name: { default: '' },
    title: { default: '' },
    width: { default: '100%' },
    height: { default: '100%' },
    maxWidth: {},
    maxHeight: {},
    minHeight: {},
    cover: { type: Boolean },
    fill: { type: Boolean },
    contain: { type: Boolean },
    borderRadius: { type: Boolean },
    version: {}
  },
  setup(__props: any) {

const props = __props;

const objectFit = computed((): string => {
  if (props.cover) {
    return 'cover';
  }
  if (props.fill) {
    return 'fill';
  }
  if (props.contain) {
    return 'contain';
  }

  return 'none';
});

const newDevSrc: Ref<string | undefined> = ref(undefined);
const newSrc: Ref<string | undefined> = ref(undefined);

const updateSrc = () => {
  if (props.src && process.env.VUE_APP_IS_DEV === 'true') {
    let img = new Image();

    img.src = props.src;
    newDevSrc.value = img.src;
    img.onerror = function () {
      if (props.src) {
        newDevSrc.value = img.src.replace(
          'https://xn--d1aefpjv.xn--p1ai/',
          'http://localhost:13010/',
        );
      }
    };
    if (props.version && newDevSrc.value) {
      let imgWithVersion = new Image();
      const srcWithVersion = newDevSrc.value.replace(
        'uploads',
        `preview/${props.version}/uploads`,
      );

      imgWithVersion.src = srcWithVersion;

      imgWithVersion.onload = function () {
        newDevSrc.value = srcWithVersion;
      };
    }
  } else if (props.version && props.src) {
    newSrc.value = props.src.replace('uploads', `preview/${props.version}/uploads`);
  }
};

onMounted(() => {
  updateSrc();
});

watch(
  () => props.src,
  () => {
    updateSrc();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([
      {
        width: _ctx.width === '100%' ? _ctx.width : _ctx.width + 'px',
        height: _ctx.height === '100%' ? _ctx.height : _ctx.height + 'px',
      },
    ])
  }, [
    _createElementVNode("img", {
      alt: _ctx.name,
      class: _normalizeClass([[
        {
          borderRadius: _ctx.borderRadius,
        },
      ], "custom-img"]),
      src: newDevSrc.value ?? newSrc.value ?? _ctx.src ?? require('@/assets/img/common/not-image.jpg'),
      style: _normalizeStyle([
        {
          width: _ctx.width === '100%' ? _ctx.width : _ctx.width + 'px',
          height: _ctx.height === '100%' ? _ctx.height : _ctx.height + 'px',
          objectFit: objectFit.value,
          maxWidth: _ctx.maxWidth,
          maxHeight: _ctx.maxHeight,
          minHeight: _ctx.minHeight,
        },
      ]),
      title: _ctx.title
    }, null, 14, _hoisted_1)
  ], 4))
}
}

})